import { createFileRoute } from '@tanstack/react-router';
import { MarketingShell } from '@/components/marketing/MarketingShell';
import { TerminosPage } from '@/components/marketing/LegalPages';

export const Route = createFileRoute('/_public/terminos')({
  component: () => (
    <MarketingShell currentPath="/terminos">
      <TerminosPage />
    </MarketingShell>
  ),
});
